import { render, staticRenderFns } from "./ConfigureSkill.vue?vue&type=template&id=6d05f8c1&"
import script from "./ConfigureSkill.vue?vue&type=script&lang=js&"
export * from "./ConfigureSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports